import React from "react";
import {RegulationComponentsCommon} from "../../regulation-components-common";
import {DenmarkResponsibleGamingButtonsComponent} from "../../../../components/responsible-gambling/responsible-gaming-buttons/regulations/denmark/denmark.responsible-gaming-buttons.component";
import { LastLoginSessionTimerSwitcherComponent } from "../../../../components/clock-and-last-login-box/last-login-session-timer-switcher/last-login-session-timer-switcher.component";

export class DenmarkRegulationComponents extends RegulationComponentsCommon {
    renderHeaderRegulationIcons() {
        return (
            <DenmarkResponsibleGamingButtonsComponent/>
        );
    }

    renderLastLoginComponent() {
        return (<LastLoginSessionTimerSwitcherComponent />)
    }
}